  import { CommonModule, DatePipe } from '@angular/common';
  import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
  import { FormGroup, FormsModule } from '@angular/forms';
  import { ActivatedRoute, RouterModule } from '@angular/router';
  import { NgxEchartsDirective, ThemeOption, provideEcharts } from 'ngx-echarts';
  import { SidebarModule } from 'primeng/sidebar';
  import { DialogModule } from 'primeng/dialog';
  //primeng
  import { TranslateModule } from '@ngx-translate/core';
  import { EChartsOption } from 'echarts';
  import {
    ApexAxisChartSeries,
    ApexChart, ApexDataLabels, ApexLegend, ApexPlotOptions, ChartComponent, NgApexchartsModule
  } from 'ng-apexcharts';
  import { ToastrService } from 'ngx-toastr';
  import { AccordionModule } from 'primeng/accordion';
  import { ConfirmationService } from 'primeng/api';
  import { ButtonModule } from 'primeng/button';
  import { CalendarModule } from 'primeng/calendar';
  import { CheckboxModule } from 'primeng/checkbox';
  import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
  import { DropdownModule } from 'primeng/dropdown';
  import { FileUploadModule } from 'primeng/fileupload';
  import { IconFieldModule } from 'primeng/iconfield';
  import { InputIconModule } from 'primeng/inputicon';
  import { InputTextModule } from 'primeng/inputtext';
  import { InputTextareaModule } from 'primeng/inputtextarea';
  import { MessagesModule } from 'primeng/messages';
  import { PanelModule } from 'primeng/panel';
  import { RadioButtonModule } from 'primeng/radiobutton';
  import { StepperModule } from 'primeng/stepper';
  import { TableModule } from 'primeng/table';
  import { TagModule } from 'primeng/tag';
  import { TooltipModule } from 'primeng/tooltip';
  import { Subscription } from 'rxjs';
  import { DateRangeValidatorDirective } from '../../../directives/date-range.directive';
  import { NotificationTypesEnum } from '../../../interfaces';
  import { authUser } from '../../../interfaces/auth/auth.model';
  import { Goal } from '../../../interfaces/models/goal.model';
  import { Indicator, Outcome, Proof } from '../../../interfaces/models/indicator.model';
  import { Pillar, Strategy } from '../../../interfaces/models/strategy.model';
  import { CoolTheme } from '../../../interfaces/models/testEchart.model';
  import { AuthService } from '../../../services/auth.service';
  import { ChartsService } from '../../../services/charts.service';
  import { DirectionService } from '../../../services/direction.service';
  import { IndicatorsService } from '../../../services/indicators.service';
  import { NotificationService } from '../../../services/notification.service';
  import { StrategyService } from '../../../services/strategy.service';
  import { indicatorResultColumns } from '../../../static-data/table.data';
  import { IndicatorFileAudtiorComponent } from '../../indicator-file-audtior/indicator-file-audtior.component';
  import { SocketService } from '../../../services/socket.service';
  import { CustomAblePipe } from '../../../pipes/able.pipe';
  import { FileUploadValidationService } from '../../../services/file-upload-validation.service';
  import { filterActive } from '../../../utils/filter-active';
  export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    dataLabels: ApexDataLabels;
    plotOptions: ApexPlotOptions;
    legend: ApexLegend;
    colors: string[];
  };


  @Component({
    selector: 'app-create-indicator',
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      RouterModule,
      TableModule,
      ButtonModule,
      IconFieldModule,
      InputTextModule,
      InputIconModule,
      DropdownModule,
      RadioButtonModule,
      StepperModule,
      CalendarModule,
      PanelModule,
      AccordionModule,
      InputTextareaModule,
      TagModule,
      FileUploadModule,
      TooltipModule,
      ConfirmPopupModule,
      NgxEchartsDirective,
      NgApexchartsModule,
      DateRangeValidatorDirective,
      TranslateModule,
      MessagesModule,
      CheckboxModule,
      DialogModule,
      CommonModule,
      IndicatorFileAudtiorComponent,
      SidebarModule,
      CustomAblePipe
    ],
    providers: [DatePipe, ConfirmationService, NgxEchartsDirective, provideEcharts()],
    templateUrl: './create-indicator.component.html',
    styleUrl: './create-indicator.component.scss'
  })
  export class CreateIndicatorComponent implements OnInit, OnDestroy {
    outcomeStatusValuesLocale = {
      ar: {
        "not_started": "لم تبدأ",
        "in_progress": "قيد التنفيذ",
        "completed": "نفذت",
        "approved": "معتمدة",
        "pending": "قيد المراجعة",
        "rejected": "مرفوضة",
        "awaiting_upload": "في انتظار المرفقات"
      },
      en: {
        "not_started": "Not Started",
        "in_progress": "In Progress",
        "completed": "Completed",
        "approved": "Approved",
        "pending": "Pending",
        "rejected": "Rejected",
        "awaiting_upload": "Awaiting Upload"
      }
    };
    outcomeStatusValues = this.outcomeStatusValuesLocale.ar;
    @ViewChild('indicatorForm') indicatorForm!: any;
    @ViewChild('TargetForm') targetForm!: any;
    @ViewChild('ReslutForm') reslutForm!: any;
    @ViewChild('dateForm') dateForm!: any;
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
    assessmentSidebarVisible = false;
    minStartegyDate !: Date;
    filesMetaData: any[] = [];
    maxStrategyDate!: Date;
    theme!: string | ThemeOption;
    coolTheme = CoolTheme;
    options!: EChartsOption;
    columns = indicatorResultColumns
    chartType = 'column-due' // الافتراضي
    set active(value: number) {

      if (value == 2) {
        this.updatesOutcomes();
      }

      this._active = value;

    }
    get active() {
      return this._active;
    }
    _active = 0;
    submitted = true;
    strategyId = 0;
    pillars = [] as Pillar[];
    goals = [] as Goal[];
    filterdgoals = [] as Goal[];
    employees = []
    outcomes = [] as Outcome[];
    balancedPerspectives = []
    indicatorCategories = []
    measurementUnitDirections = []
    measurementCycles = []
    measurementUnits = []
    indicatorId = 0;
    mediaFiles!: FileList;
    outcomeId = 0;
    user!: authUser;
    isResulSubmitted = false;
    indicatorSubscription!: Subscription;
    indicatorRelationSubscription!: Subscription;
    @ViewChild("chart") chart!: ChartComponent;
    public chartOptions!: any;
    chartDueOptions!: any;
    chartMarkerOptions!: any;
    isProofModal = false;
    Proofs = [] as Proof[]

    dir!: 'rtl' | 'ltr';
    locale!: "ar" | "en";
    colorMap = {} as any;
    _isUploadConfirmed = false;
    set isUploadConfirmed(value: boolean) {
      this._isUploadConfirmed = value;
    }
    get isUploadConfirmed() {
      return this._isUploadConfirmed;
    }
    outputMessageWarinig = [{ severity: 'info', detail: 'Info Message' }];

    uploadedFilesCount: number = this.filesMetaData.filter(x => !x.is_deleted).length
    ogFileList!: any[];
    selectedOutcome = {} as Outcome;
    
    // Section collapse state
    sectionsExpanded = {
      strategicLink: false,
      indicatorData: false,
      outcomes: false,
      responsibility: false
    };

    constructor(
      private indicatorsService: IndicatorsService,
      private route: ActivatedRoute,
      private datePipe: DatePipe,
      private toastr: ToastrService,
      private confirmationService: ConfirmationService,
      private authService: AuthService,
      private strategyService: StrategyService,
      private directionService: DirectionService,
      private notificationService: NotificationService,
      private chartsService: ChartsService,
      private socketService: SocketService,
      private fileValidation: FileUploadValidationService
    ) { }

    ngOnDestroy(): void {

      if (this.indicatorSubscription) {
        this.indicatorSubscription.unsubscribe()
      }
      if (this.indicatorRelationSubscription) {
        this.indicatorRelationSubscription.unsubscribe();
      }
    }
    ngOnInit(): void {
      this.strategyId = +(this.route.snapshot.paramMap.get('strategyId') ?? '0')
      this.indicatorId = +(this.route.snapshot.paramMap.get('indicatorId') ?? '0')

      //todo 
      this.strategyService.getStrategyById(this.strategyId.toString()).subscribe((response: any) => {
        const strategy = response['data']['strategy'] as Strategy
        this.minStartegyDate = new Date(strategy.start_date);
        this.maxStrategyDate = new Date(strategy.end_date);
      })

      if (this.indicatorId) {
        this.indicatorRelationSubscription = this.indicatorsService.indicatorRelation(this.strategyId, this.indicatorId)
          .subscribe((response: any) => {
            const {
              pillars,
              goals,
              employees,
              balancedPerspectives,
              indicatorCategories,
              measurementUnitDirections,
              measurementCycles,
              measurementUnits
            } = response['data'];
            this.pillars = filterActive(pillars);
            this.goals = filterActive(goals);
            this.filterdgoals = this.goals;
            this.employees = filterActive(employees);
            this.balancedPerspectives = balancedPerspectives;
            this.indicatorCategories = indicatorCategories;
            this.measurementUnitDirections = measurementUnitDirections;
            this.measurementCycles = measurementCycles;
            this.measurementUnits = measurementUnits;
          })
      } else {
        this.indicatorRelationSubscription = this.indicatorsService.newIndicatorRelation(this.strategyId)
          .subscribe((response: any) => {
            const {
              pillars,
              goals,
              employees,
              balancedPerspectives,
              indicatorCategories,
              measurementUnitDirections,
              measurementCycles,
              measurementUnits
            } = response['data'];
            this.pillars = filterActive(pillars);
            this.goals = filterActive(goals);
            this.filterdgoals = this.goals;
            this.employees = filterActive(employees);
            this.balancedPerspectives = balancedPerspectives;
            this.indicatorCategories = indicatorCategories;
            this.measurementUnitDirections = measurementUnitDirections;
            this.measurementCycles = measurementCycles;
            this.measurementUnits = measurementUnits;
            this.indicator.IS_ALLOWED_TO_EDIT = true;
          })
      }




      if (this.indicatorId > 0) {
        this.indicatorRelationSubscription = this.indicatorsService.getIndicator(this.strategyId, this.indicatorId).subscribe((response: any) => {
          this.indicator = {
            ...response['data']['indicator'],
            start_date: new Date(response['data']['indicator']["start_date"]),
            end_date: new Date(response['data']['indicator']["end_date"])
          }
          this.outcomes = response['data']['indicator']['outcomes'] as Outcome[];
          this.indicatorId = response['data']['indicator']['id'];
          //charts
          this.chartDueOptions = this.chartsService.getColumnChartOptions(response['data']['indicator'], this.dir);
          this.chartMarkerOptions = this.chartsService.getMarkerChartOptions(response['data']['indicator'], this.setCustomLegendItems(), this.dir);
        })
      }
      this.authService.authBufferSub$.subscribe(user => {
        this.user = user || {} as authUser;
      })

      this.directionService.direction$.subscribe((dir) => {
        this.dir = dir;
        this.locale = dir == "rtl" ? "ar" : "en";
        this.setCustomLegendItems();

        if (this.indicatorId) {
          this.indicatorRelationSubscription = this.indicatorsService.getIndicator(this.strategyId, this.indicatorId).subscribe((response: any) => {
            this.indicator = {
              ...response['data']['indicator'],
              start_date: new Date(response['data']['indicator']["start_date"]),
              end_date: new Date(response['data']['indicator']["end_date"])
            }
            this.outcomes = response['data']['indicator']['outcomes'] as Outcome[];
            this.indicatorId = response['data']['indicator']['id'];
            //charts
            this.chartDueOptions = this.chartsService.getColumnChartOptions(response['data']['indicator'], this.dir);
            this.chartMarkerOptions = this.chartsService.getMarkerChartOptions(response['data']['indicator'], this.setCustomLegendItems(), this.dir);
          })

        }

      })
    }





    //=========isProofModal=======
    closeProofModal() {
      this.isProofModal = false;
    };

    openProofModal(id: number) {
      this.outcomeId = id;
      this.selectedOutcome = this.outcomes.find(x => x.id === id) as Outcome;

      this.indicatorsService.ListOutcomeProofs(this.strategyId, this.indicatorId, id).subscribe((proofs) => {
        this.Proofs = proofs;
      })
      this.isProofModal = true;
    }

    //====== ResultModal start======
    actualOutcomeDataModal = {} as Outcome;
    isActualModal = false

    submitResult() {
      this.isResulSubmitted = true;
      let formData: any = new FormData();
      formData.append("actual", this.actualOutcomeDataModal.actual)
      formData.append("source", this.actualOutcomeDataModal.source)
      formData.append("causality", this.actualOutcomeDataModal.causality)
      formData.append("corrective_actions", this.actualOutcomeDataModal.corrective_actions);
      const toBeUploadedFiles = this.filesMetaData.filter(x => !x.is_deleted);
      toBeUploadedFiles.forEach(toBeUploadedFile => {
        const file = Array.from(this.mediaFiles).find(x => x.name == toBeUploadedFile.name)
        formData.append("mediaFiles", file)
      });


      if (this.reslutForm.valid) {
        this.indicatorsService.updateOutcomeActual(this.strategyId, this.indicatorId, this.actualOutcomeDataModal.id, formData)
          .subscribe((response: any) => {
            this.isResulSubmitted = false;
            this.toastr.success("تم التحديث بنجاح", "عملية ناجحة")
            this.isActualModal = false;
            this.notificationService.pushAuditRequest(
              this.strategyId, {
              id: response["data"]["uploadedFilesIds"][0],
              parentEntityId: this.indicatorId,
              subEntityId: this.outcomeId,
              type: NotificationTypesEnum.outcome_proof_audit_request
            },
              this.locale
            );
            this.getFreshStatus(this.strategyId, this.indicatorId, this.actualOutcomeDataModal.id)
            this.filesMetaData = [];
          }, (err => {
            this.getFreshStatus(this.strategyId, this.indicatorId, this.actualOutcomeDataModal.id)
          }))
      } else {
        this.toastr.error(this.dir == 'rtl' ? 'يرجى مراجعة وإكمال البيانات' : 'Please review the information')
      }
    }

    openResultModal(outcomeId: number) {
      this.outcomeId = outcomeId;
      const obj = this.outcomes.find(x => x.id == outcomeId) as Outcome;
      this.actualOutcomeDataModal = { ...obj, causality: obj?.causality.trim(), corrective_actions: obj.corrective_actions.trim() } as Outcome;
      this.isActualModal = true;
    };

    closeActualModal() {
      this.filesMetaData = [];
      this.actualOutcomeDataModal = {} as Outcome;
      this.isActualModal = false;
      this.isUploadConfirmed = false;
      const dataTransfer = new DataTransfer();
      this.fileInput.nativeElement.files = dataTransfer.files;
    };

    onFileChange(event: Event) {
      const input = event.target as HTMLInputElement;
      if (!input.files || input.files.length === 0) {
        return;
      }

      const validation = this.fileValidation.validateFiles(input.files, {
        maxCount: FileUploadValidationService.INDICATOR_PROOF_MAX_FILES
      });
      if (!validation.valid) {
        input.value = '';
        this.toastr.error(this.dir === 'rtl' ? 'نوع الملف أو الحجم غير مسموح' : 'File type or size is not allowed.');
        return;
      }

      this.ogFileList = Array.from(input.files);
      this.mediaFiles = input.files;
      for (let i = 0; i < this.mediaFiles.length; i++) {
        if (this.actualOutcomeDataModal.current == this.actualOutcomeDataModal.limit) {
          this.toastr.error('لا يسمح برفع مزيد من المخرجات بعد استيفاء الحد الأقصى', 'فشل');
          return;
        }
        this.actualOutcomeDataModal.current = +this.actualOutcomeDataModal.current + 1;
        this.actualOutcomeDataModal.left = +this.actualOutcomeDataModal.left - 1;
        const { name, type, size } = this.mediaFiles[i];
        const extension = this.fileValidation.getExtension(name);
        let icon = 'fa-solid fa-file';
        let color = 'gray';
        if (['.png', '.jpg', '.jpeg', '.gif', '.webp'].includes(extension)) {
          icon = 'fa-solid fa-file-image';
        } else if (['.doc', '.docx'].includes(extension)) {
          icon = 'fa-solid fa-file-word';
          color = 'blue';
        } else if (extension === '.pdf') {
          icon = 'fa-solid fa-file-pdf';
          color = 'red';
        }
        this.filesMetaData.push({ name, type, size, icon, color });
        this.uploadedFilesCount = this.filesMetaData.filter(x => !x.is_deleted).length;
      }
    };

    deleteFile(index: number) {
      this.actualOutcomeDataModal.current = this.actualOutcomeDataModal.current - 1;
      this.actualOutcomeDataModal.left = this.actualOutcomeDataModal.left + 1;
      this.filesMetaData[index].is_deleted = true;
      this.uploadedFilesCount = this.filesMetaData.filter(x => !x.is_deleted).length;
      const dataTransfer = new DataTransfer();
      this.ogFileList = this.ogFileList.filter((file) => {
        return this.filesMetaData.filter(x => x.name == file.name && !x.is_deleted)[0]
      })
      this.ogFileList.forEach(file => dataTransfer.items.add(file as File));
      this.fileInput.nativeElement.files = dataTransfer.files;
    };

    // ======ResultModal end======
    //====== TargetModal start======
    isTargetModal = false
    submitTarget() {
      this.indicatorsService.updateTargetOutcome(this.strategyId, this.indicatorId, this.targetDataModal.id, { target: +this.targetForm.value['target'] })
        .subscribe((x) => {
          this.toastr.success("تم التحديث بنجاح", "عملية ناجحة")
          this.isTargetModal = false;
          this.updatesOutcomes();
        })
    };

    targetDataModal = {} as Outcome
    openTargetModal(outcomeId: number) {
      this.targetDataModal = this.outcomes.find(x => x.id == outcomeId) || {} as Outcome;
      console.log("outcomeId", outcomeId);
      console.log("targetDataModal", this.targetDataModal);
      this.isTargetModal = true;
    };

    closeTargetModal() {
      this.targetDataModal = {} as Outcome;
      this.isTargetModal = false;
    };

    // ====== TargetModal end ======
    indicator = {
      id: 0,
      pillar_id: 0,
      strategic_goal_id: null,
      uuid: "",
      code: "",
      balanced_perspective: "",
      category: "",
      name: "",
      name_en: "",
      description: "",
      description_en: "",
      measurement_formula: "",
      measurement_unit_direction: "",
      target: "",
      measurement_cycle: "",
      target_reference: "",
      base_line: "",
      results_display_cycle: "",
      data_source: "",
      data_storage_location: "",
      in_charge_id: null,
      in_charge_review_id: null,
      in_charge_data_entry_id: null,
      start_date: new Date(),
      end_date: new Date(),
      deleted_at: null,
      is_deleted: false,
      measurement_unit: "",
      strategic_plan_id: null,
      measurement_cycle_ar: "",
      pillar_name: "",
      in_charge_name: "",
      in_charge_data_entry_name: "",
      in_charge_review_name: "",
      IS_ALLOWED_TO_VIEW: true,
      IS_ALLOWED_TO_EDIT: true,
      created_at: new Date(),
      weight: 0,
    } as Indicator;
    onGoalChange(goalControl: any) {
      const selectedGoalId = +goalControl.value;
      const selectedGoal = this.goals.find(x => x.id == selectedGoalId);
      const selectedPillar = this.pillars.find(x => x.id == selectedGoal?.pillar_id)
      this.indicator.pillar_id = selectedPillar?.id || 0;

      const code = `${selectedGoal?.code}-KPI-${parseInt(selectedGoal?.no_indicators!) + 1}`
      this.indicator.code = code;
    }
    onPillarChange(indicatorControl: any) {
      const pillarId = +indicatorControl.value;
      console.log("pillarId", pillarId);

      const filterdGoals = this.goals.filter(x => x.pillar_id == pillarId);
      this.filterdgoals = filterdGoals;
    }
    submitIndicator() {
      // code
      if (this.indicatorId > 0) {
        const {
          pillar_id,
          strategic_goal_id,
          in_charge_id,
          in_charge_review_id,
          name,
          code,
          balanced_perspective,
          category,
          description,
          measurement_formula,
          measurement_unit_direction,
          measurement_unit,
          measurement_cycle,
          target,
          target_reference,
          base_line,
          weight,
          results_display_cycle,
          data_source,
          data_storage_location,
          start_date,
          end_date
        } = this.indicator;

        const indicator = {
          pillar_id,
          strategic_goal_id,
          in_charge_id,
          in_charge_review_id,
          name,
          name_en: this.indicator.name_en,
          code,
          balanced_perspective,
          category,
          description,
          description_en: this.indicator.description_en,
          measurement_formula,
          measurement_unit_direction,
          measurement_unit,
          measurement_cycle,
          target,
          weight,
          target_reference,
          base_line,
          results_display_cycle,
          data_source,
          data_storage_location,
          start_date,
          end_date
        } as Indicator;
        if (this.indicatorForm.pristine) {
          this.active = 1;
        }
        else {



          this.indicatorsService.updateIndicator({
            ...indicator,
            start_date: this.datePipe.transform(new Date(indicator.start_date), 'MM/dd/yyyy') as any,
            end_date: this.datePipe.transform(new Date(indicator.end_date), 'MM/dd/yyyy') as any,
          }, this.strategyId, this.indicatorId).subscribe((response: any) => {
            this.toastr.success("تم التحديث بنجاح", "عملة ناجحة");
            this.active = 1;
          })
        }
      } else {
        const in_charge_data_entry_id = this.indicatorForm.value['in_charge_data_entry_id']
        console.log("indicator.code", this.indicator.code);
        const start_date = this.dateForm?.value?.['start_date'];
        const end_date = this.dateForm?.value?.['end_date'];
        // Ensure enums are sent as names (strings), not numeric ids from the form
        const payload = {
          ...this.indicatorForm.value,
          code: this.indicator.code,
          start_date: this.datePipe.transform(new Date(start_date), 'MM/dd/yyyy'),
          end_date: this.datePipe.transform(new Date(end_date), 'MM/dd/yyyy'),
          in_charge_data_entry_id: +in_charge_data_entry_id,
          balanced_perspective: this.indicator.balanced_perspective,
          category: this.indicator.category,
          measurement_unit_direction: this.indicator.measurement_unit_direction,
          measurement_unit: this.indicator.measurement_unit,
          measurement_cycle: this.indicator.measurement_cycle,
          results_display_cycle: this.indicator.results_display_cycle,
        } as any;

        this.indicatorsService.createIndicator(payload, this.strategyId).subscribe((response: any) => {
          this.outcomes = response['data']['entity']['outcomes'] as Outcome[];
          this.indicatorId = response['data']['entity']['id'];
          this.indicatorForm.reset({})
          this.active = 1;
        })
      }
    }

    confirmProofDelete(event: Event, id: number) {
      const target = event.target as HTMLElement;
      this.confirmationService.confirm({
        target: target,
        message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.indicatorsService.deleteProof(this.strategyId, this.indicatorId, this.outcomeId, id).subscribe((data) => {
            this.Proofs = this.Proofs.filter(proof => proof.id != id);

            this.toastr.success(this.dir == 'rtl' ? 'تمت المسح ' : 'The proof has been deleted successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
            // this.toastr.success("تمت المسح ", "عملية ناجحة");
            this.getFreshStatus(this.strategyId, this.indicatorId, this.outcomeId);
          }, (err) => {
            this.getFreshStatus(this.strategyId, this.indicatorId, this.outcomeId);
            this.toastr.success(this.dir == 'rtl' ? 'فشل المسح ' : 'The proof deletion failed.', this.dir == 'rtl' ? 'فشل' : 'Failed');
          })
        },

        reject: () => {
          this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
        }
      });
    };

    accept() {
      this.confirmPopup.accept();
    };

    reject() {
      this.confirmPopup.reject();
    };

    downloadProof(proofId: number, file_name: string) {
      this.indicatorsService.downloadOutcomeProof(this.strategyId, this.indicatorId, this.outcomeId, proofId).subscribe(x => {
        const blob = new Blob([x], { type: x.type });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = file_name;
        anchor.click();
        window.URL.revokeObjectURL(url);
      })
    };

    triggerFileInput() {
      this.fileInput.nativeElement.click();
    };

    customLegendItems!: string[];

    setCustomLegendItems() {
      this.customLegendItems = this.dir == 'rtl' ?
        structuredClone(["المستهدف", "محقق بشكل ايجابي", "محقق بشكل سلبي"]) :
        structuredClone(["Target", "Positive Actual", "Negative Actual"])
      return this.customLegendItems
    };

    updatesOutcomes() {
      this.indicatorRelationSubscription = this.indicatorsService
        .getIndicator(this.strategyId, this.indicatorId).subscribe((response: any) => {
          const metaData = {
            name: response['data']['indicator'].name,
            in_charge_name: response['data']['indicator'].in_charge_name,
          }
          this.indicator = {
            ...response['data']['indicator'],
            start_date: new Date(response['data']['indicator']["start_date"]),
            end_date: new Date(response['data']['indicator']["end_date"])
          }
          this.outcomes = response['data']['indicator']['outcomes'] as Outcome[];
          this.indicatorId = response['data']['indicator']['id'];

          this.chartDueOptions = this.chartsService.getColumnChartOptions(response['data']['indicator'], this.dir);
          this.chartMarkerOptions = this.chartsService.getMarkerChartOptions(response['data']['indicator'], this.setCustomLegendItems(), this.dir);
        })
    };

    openAssessmentSidebar() {
      this.assessmentSidebarVisible = true;
    };

    closeAssessmentSidebarVisible() {
      this.assessmentSidebarVisible = false;
    };
    
    /**
     * تحديد لون عرض النتيجة بناءً على المقارنة بين المحقق والمستهدف
     * أخضر: إذا المحقق يساوي أو أكبر من المستهدف
     * أحمر: إذا المحقق أقل من المستهدف
     * Get performance color class based on actual vs target comparison
     * Green: if actual >= target (achieved or exceeded)
     * Red: if actual < target (below target)
     */
    getPerformanceClass(target: any, actual: any): string {
      // تحويل القيم إلى أرقام للتأكد من المقارنة الصحيحة
      const targetNum = Number(target);
      const actualNum = Number(actual);
      
      // إذا لم يكن هناك هدف أو القيمة صفر أو ليست رقم
      if (!targetNum || targetNum === 0 || isNaN(targetNum)) return 'performance-neutral';
      
      // إذا لم يكن هناك قيمة محققة أو ليست رقم
      if (isNaN(actualNum)) return 'performance-neutral';
      
      // أخضر للإيجابي (المحقق >= المستهدف)، أحمر للسلبي (المحقق < المستهدف)
      return actualNum >= targetNum ? 'performance-excellent' : 'performance-poor';
    }
    
    getPerformancePercentage(target: any, actual: any): number {
      const targetNum = Number(target);
      const actualNum = Number(actual);
      
      if (!targetNum || targetNum === 0 || isNaN(targetNum)) return 0;
      if (isNaN(actualNum)) return 0;
      
      return Math.round((actualNum / targetNum) * 100);
    }

    /**
     * الحصول على اللون المباشر بناءً على المقارنة
     */
    getPerformanceColor(target: any, actual: any): string {
      const targetNum = Number(target);
      const actualNum = Number(actual);
      
      if (!targetNum || targetNum === 0 || isNaN(targetNum)) {
        return 'linear-gradient(135deg, #94a3b8, #64748b)';
      }
      
      if (isNaN(actualNum)) {
        return 'linear-gradient(135deg, #94a3b8, #64748b)';
      }
      
      // أحمر للمحقق الأقل من المستهدف، أخضر للمحقق المساوي أو الأكبر
      return actualNum >= targetNum 
        ? 'linear-gradient(135deg, #10b981, #059669)' // Green
        : 'linear-gradient(135deg, #ef4444, #dc2626)'; // Red
    }

    onFileReviewed(event: any) {
      this.indicatorRelationSubscription = this.indicatorsService.getIndicator(this.strategyId, this.indicatorId).subscribe((response: any) => {
        this.indicator = { ...response['data']['indicator'], start_date: new Date(response['data']['indicator']["start_date"]), end_date: new Date(response['data']['indicator']["end_date"]) }
        this.outcomes = response['data']['indicator']['outcomes'] as Outcome[];
        this.indicatorId = response['data']['indicator']['id'];

        //charts
        this.chartDueOptions = this.chartsService.getColumnChartOptions(response['data']['indicator'], this.dir);
        this.chartMarkerOptions = this.chartsService.getMarkerChartOptions(response['data']['indicator'], this.setCustomLegendItems(), this.dir);







      })




    };

    getFreshStatus(strategyId: number, indicatorId: number, outcomeId: number) {
      console.log("getFreshStatus", strategyId, indicatorId, outcomeId);
      return this.indicatorsService.getOutcomeStatus(strategyId, indicatorId, outcomeId).subscribe((response: any) => {
        const data = response.data;
        this.selectedOutcome = this.outcomes.find(x => x.id === outcomeId) as Outcome;
        this.outcomes = this.outcomes.map(x => {
          if (x.id === outcomeId) {
            return { ...x, ...data }
          } else {
            return x;
          }
        });
        
        // تحديث actualOutcomeDataModal إذا كان مفتوحاً
        if (this.actualOutcomeDataModal.id === outcomeId) {
          this.actualOutcomeDataModal = { ...this.actualOutcomeDataModal, ...data };
        }
      });
    };

    setOutcomeStatusLocale() {
      this.outcomeStatusValues = this.dir == 'rtl' ? this.outcomeStatusValuesLocale.ar : this.outcomeStatusValuesLocale.en;
    };

    goBack() {
      window.history.back();

    }
    
    toggleSection(section: 'strategicLink' | 'indicatorData' | 'outcomes' | 'responsibility') {
      this.sectionsExpanded[section] = !this.sectionsExpanded[section];
    }

};